import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { AirlineIncentivesPageContent } from "./AirlineIncentivesPageContent";
import { AirlineIncentivesPageHeading } from "./AirlineIncentivesPageHeading";
import { AirlineIncentivesNextPage } from "./AirlineIncentivesNextPage";

export const AirlineIncentives = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "airlineIncentivesPageHeading",
      children: <AirlineIncentivesPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "airlineIncentivesPageContent",
      children: <AirlineIncentivesPageContent/>
    },
    {
      label: "Next Page",
      key: "airlineIncentivesNextPage",
      children: <AirlineIncentivesNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("thirdChildActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
